import React from 'react';
import { Icon } from './Icon.js';
export const IconFlag4Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M14.241,5.577L4.01,1.796s-.007,0-.01,0V11.705s.007,0,.01-.002l10.231-3.781c.496-.184,.816-.644,.816-1.173s-.32-.989-.817-1.173Z", fill: "currentColor" }),
        React.createElement("path", { d: "M3.75,17c-.414,0-.75-.336-.75-.75V1.75c0-.414,.336-.75,.75-.75s.75,.336,.75,.75v14.5c0,.414-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconFlag4Fill18.js.map